import {
  CalendarEventDetails,
  ExternalConnectionsProviders,
} from '@griply/types';

import { shouldAskGuestNotification } from './should-ask-guest-notification';

export type GetExternalEventDragQuestionsOptions = {
  provider?: ExternalConnectionsProviders;
  // null when the detail fetch failed — the list payload still answers the occurrence question
  details: CalendarEventDetails | null;
  listIsRecurring?: boolean;
};

export type ExternalEventDragQuestions = {
  asksOccurrence: boolean;
  asksAboutGuests: boolean;
};

// a false/absent detail flag only means "not known to repeat" — the list payload still answers, so a failed fetch cannot detach a series
export const getExternalEventDragQuestions = ({
  provider,
  details,
  listIsRecurring,
}: GetExternalEventDragQuestionsOptions): ExternalEventDragQuestions => ({
  asksOccurrence: !!listIsRecurring || !!details?.isRecurring,
  asksAboutGuests: shouldAskGuestNotification({
    provider,
    guests: details?.guests ?? [],
    organizer: details?.organizer,
  }),
});
